






























import { Vue, Component } from "vue-property-decorator";

@Component
export default class addMark extends Vue {
  private url: string = "";
  private title: string = "";
  private isDisable: boolean = false; //防止重复提交

  public add() {
    // 防止重复提交
    this.isDisable = true;
    var data = JSON.stringify({
      url: this.url,
      title: this.title,
    });
    // @ts-ignore
    this.$httpService.postData(data, true, "addMark", "application/json").then(
      (result: any) => {
        // @ts-ignore
        this.$store.commit("getMarkList");
        // 防止重复提交
        this.isDisable = false;
        this.updateIcon();
      },
      (error: any) => {
           // 防止重复提交
        this.isDisable = false;
      }
    );
  }

  // 添加文件夹
  public addFolder() {
    this.isDisable = true;
    let data = new FormData()
    data.append('title',this.title)
    // @ts-ignore
    this.$httpService.postData(data, true, "addFolder", "application/x-www-from-urlencoded").then(
      (result: any) => {
        // @ts-ignore
        this.$store.commit("getMarkList");
        this.isDisable = false;
        this.updateIcon();
      },
      (error: any) => {
           // 防止重复提交
        this.isDisable = false;
      }
    );
  }

  public updateIcon() {
    // @ts-ignore
    var store = this.$store
    let i = 0;
    var myVar = setInterval(function () {
      //TODO 知识总结
      // @ts-ignore
      const list: any = JSON.parse(localStorage.getItem("markList"));
      i++;
      if (list[list.length - 1].icon || i == 10) {
        // 退出轮询
        clearInterval(myVar);
      }
      // 关闭消息提示
      store.commit("setMsFlag",false);
      store.commit("getMarkList"); //TODO 不要提示更新成功这几个字
    }, 3000);
  }
}
